export default __webpack_public_path__ + "static/media/cash.08c63a5e.svg";